import { BaseSettings, BaseThemeType } from 'Shared/frontend/themes/BaseSettings';
import { merge } from 'Shared/frontend/merge';
import { DeepPartial } from 'Shared/frontend/SettingsProvider';
import { OpenSans } from 'Shared/frontend/fonts/OpenSans';
import { Oswald } from 'Shared/frontend/fonts/Oswald';


export class ChippoSettings extends BaseSettings
{
	palette()
	{
		return {
			
			background: 'white',
			text: 'black',
			feature: '#173E5D', //Chippo Blue
			feature2: '#F9BA19', //Chippo Yellow
			feature3: '#d91f0e !important', //Chippo Red

		
			dimBackground: '#FEB710',

			food: '', 
			drinks: '',
			
			// CJ added: needed to change scrollBar colors for light theme
			scrollBar: {
				scrollbarColor: '#a4bcce8c #f0f0f5 !important',
			}
		};
	}

	poster()
	{
		return merge(super.poster(), {
			shared: {
				root: {
					color: this.palette().feature2,
					backgroundColor: this.palette().feature,
				},
				dateBar: {
					color: this.palette().feature,
					backgroundColor: this.palette().feature,
				},
			},
			types: {
				overlapping: {
					name:{
						textTransform: 'initial !important',
					},
					eventInfo:{
						fontSize: '.8em !important'
					}
				},
			}
		});
	}

	fontIncludes()
	{
		return [
			OpenSans,
			Oswald 
		];
	}

	fonts() {
		return {
			text: '"Open Sans", serif',
			teaser: '"Open Sans", serif',
			heading: '"Open Sans", serif',
			tagline: '"Open Sans", serif',
			buttons: '"Open Sans", serif',
			desktopNav: '"Open Sans", serif',
			menuItem: '"Open Sans", serif',
			mobileNav: '"Open Sans", serif',
			subNav: '"Open Sans", serif',
		};
	}

	subNavButton()
	{
		return merge(super.subNavButton(), {
			borderRadius: '0.4em'
		});
	}
	
	page()
	{
		return merge(super.page(), {
			heading: {
				color: this.palette().feature,
			},
			section: {
				title: {
					color: this.palette().feature2,
					fontWeight: '700',
					fontSize:'clamp(1.8rem, 4vw, 3rem)!important',
					//	letterSpacing: 3, 
					textTransform: 'initial',
				},
				teaser:{
					color: this.palette().feature,
					fontFamily: this.fonts().teaser,
					fontWeight: '500',
					fontSize:'clamp(1.1rem, 5vw, 1.2rem)!important',	
					textTransform: 'initial !Important',
				},
				tagline:{
					color: this.palette().feature,
					fontFamily: this.fonts().tagline,
					fontWeight: '300 !important',
					fontSize:'clamp(1.2rem, 5vw, 2rem)!important',	
					textTransform: 'initial !Important',
				},
			},

			widgets: {
				subNav: {
					button: {
						backgroundColor: this.palette().text
					}
				}
			},

			button: {
				backgroundColor: this.palette().feature,
				borderRadius: '0.4em',
			},
		});
	}


	siteTheme()
	{
		const base = super.siteTheme();
		const palette = this.palette();

		const settings = merge(base, <DeepPartial<BaseThemeType>>{
			nav:{
				mobile:{		
					backgroundWrap: {background: palette.feature,},
					overlay:{background: 'red'},
				
					button:{
						background: 'red',
						color: palette.feature2,
						//icons
						svg: {
							fill: palette.feature2,
						},
					},
				},

				desktop:{
					backgroundWrap: {
						backgroundColor: 'green !important',
					}
				},

				button: {
					color: palette.feature2,
				},

				active: {
					color: palette.feature3
				},
				hover: {
					color: palette.feature3,
				}
			},

			event: {
				artist: {
					heading: {
						color: palette.feature2,
						fontFamily: 'sans-serif'
					},
					wide: {
						nameAndTime: {
							color: palette.feature
						}
					},
					//on small screen box that appears above artist image
					narrow: {
						nameAndTime: {
							backgroundColor: palette.dimBackground,
							//for time
							color: palette.feature,
							//for name
							h3:{
								color: palette.feature,
							},
						}
					}, 
					genresAndLocation: {
						color: palette.feature2
					} 
				}
			},

			//TODO share most of this with the townie. eg 'ColouredDarkTheme' parent
			menu: {
				subNav: {
					button: {
						color: palette.feature,
						border: 'solid 3px',
						borderColor: palette.feature,
					},
					buttonType: type => ({ backgroundColor: palette.background })
				},
				section: {
					heading: {
						fontFamily: this.fonts().menuItem,
						fontSize:'clamp(2rem, 20vw, 50rem)!important',
						color: palette.feature,
					},
				},
				item: {
					type: 'imageless',
					title: { 
						fontFamily: this.fonts().menuItem,
						fontSize: '1.3em',
					},
				},
			},
		});

		// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
		return settings;
	}
}

